import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import { fetchCitiesAsync, selectCity } from "../redux/searchSlice"

export default function useCityHome() {
  const dispatch = useDispatch()
  const cityHome = useSelector(selectCity)

  useEffect(() => {
    dispatch(fetchCitiesAsync())
  }, [])

  return cityHome
}
